/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {AccountInfo} from '../models/AccountInfo';
import type {Error} from '../models/Error';

export interface GetAccountPage$Request {
    accountId: number;
}

export interface GetAccountPage$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getAccountPageRequest = createAction<PayloadData<void, GetAccountPage$Request>>('ACCOUNT_INFO__GET_ACCOUNT_PAGE__REQUEST');
export const getAccountPageSuccess = createAction<PayloadData<AccountInfo, GetAccountPage$Request>>('ACCOUNT_INFO__GET_ACCOUNT_PAGE__SUCCESS');
export const getAccountPageFailure = createAction<PayloadData<Error, GetAccountPage$Request, true>>('ACCOUNT_INFO__GET_ACCOUNT_PAGE__FAILURE');

export const getAccountPageActions = [
    getAccountPageRequest,
    getAccountPageSuccess,
    getAccountPageFailure
] as const;

/**
 * @param {number} meta.accountId
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getAccountPage = (meta: GetAccountPage$Request, config?: GetAccountPage$Config) => {
    return {
        CALL_API: {
            types: getAccountPageActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/accounts/${meta.accountId}`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

